export const jobWorkplaceTypesCz = {
  jobWorkplaceTypes: {
    any: 'Nezáleží',
    office: 'Práce na pracovišti',
    home: 'Práce z domova',
    mix: 'Částečná práce z domova',
    travel: 'Práce s cestováním',
  },
};
